import { render } from "./Performance.vue?vue&type=template&id=7d446249&scoped=true&ts=true"
import script from "./Performance.vue?vue&type=script&lang=ts"
export * from "./Performance.vue?vue&type=script&lang=ts"

import "../assets/scss/users.scss?vue&type=style&index=0&id=7d446249&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d446249"]])

export default __exports__